import script from "./ConfigurationSettings.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConfigurationSettings.vue?vue&type=script&setup=true&lang=ts"

import "./ConfigurationSettings.vue?vue&type=style&index=0&id=7028cec4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7028cec4"]])

export default __exports__